import { Component } from 'vue-property-decorator';
import EditorBase from '../EditorBase';
import { Button } from 'streamlabs-beaker';
import Position from './Position.vue';
import GeneralSettings from './GeneralSettings.vue';
import VisibilityDeleteComponentButton from './VisibilityDeleteComponentButton.vue';

@Component({
  components: {
    SButton: Button,
    Position,
    GeneralSettings,
    VisibilityDeleteComponentButton,
  },
})
export default class GameCaptureSettings extends EditorBase { }
